import * as Yup from 'yup';

const validateNewPin = (value: string) => {
  const schema = Yup.string()
    .required('Please enter PIN')
    .matches(/^\d{4}$/, 'PIN must be four digits');
  return schema
    .validate(value)
    .then(() => undefined)
    .catch(({ errors }: Yup.ValidationError) => errors[0]);
};

const validateConfirmPin = (newPin: string, value: string) => {
  const schema = Yup.string().required('Please enter PIN confirm').oneOf([newPin, ''], "The entered PINs don't match");
  return schema
    .validate(value)
    .then(() => undefined)
    .catch(({ errors }: Yup.ValidationError) => errors[0]);
};

export { validateNewPin, validateConfirmPin };
